import React, { useState } from "react";
import { Scanner } from "@yudiel/react-qr-scanner";

const QRCodeScanner = ({ showScanner, setShowScanner, handleScan, dataQr }) => {
  const handleError = (error) => {
    console.error(error);
  };

  return (
    <div>
      {showScanner && (
        <div style={{ position: "relative", width: "fit-content" }}>
          <br />
          <Scanner
            onScan={handleScan}
            onError={handleError}
            constraints={{ facingMode: "environment" }}
            scanDelay={1000}
            components={{
              onOff: true, // Adds an on/off toggle
              torch: true, // Enables torch for low-light scanning
              zoom: true, // Enables zoom functionality
              finder: true, // Enables the finder overlay
            }}
            styles={{
              video: { borderRadius: "10px" },
              finderBorder: 2,
            }}
          />
          <p>
            {dataQr
              ? `${dataQr[0].format}: ${dataQr[0].rawValue}`
              : "No result"}
          </p>
          <button
            onClick={() => setShowScanner(false)}
            style={{
              position: "absolute",
              top: "20px",
              right: "10px",
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}
    </div>
  );
};

export default QRCodeScanner;
